import Vue from 'vue'

export const commonRequest = (url, params) => {
  return Vue.fetch.post(url, params)
}



// WEBPACK FOOTER //
// ./src/services/baseRequst.js